module.exports = "/_next/static/images/TSVL-00d38aa5e3e16075a7c92f534820e618.png";